export function promiseWithTimeout(
  promise,
  timeout,
  { rejectOnTimeout = true } = {}
) {
  return new Promise((resolve, reject) => {
    // Start the timeout
    const timeoutId = setTimeout(() => {
      if (rejectOnTimeout) {
        reject(new Error('Promise timed out'))
      } else {
        resolve(new Error('Promise timed out'))
      }
    }, timeout)

    // Wait for the original promise to resolve or reject
    promise
      .then((result) => {
        clearTimeout(timeoutId)
        resolve(result)
      })
      .catch((error) => {
        clearTimeout(timeoutId)
        reject(error)
      })
  })
}
